import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment-timezone';
import { SingleDateRangeFilter } from '../single-date-range/single-date-range-filter';
import { UntypedFormControl } from '@angular/forms';
import { FilteringService } from 'app/services/filtering.service';
import { Organization } from 'app/models/entities/organization';
import { OrganizationService } from 'app/services/organization/organization.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'report-filter-single-date-range-simple',
    templateUrl: './single-date-range-simple.component.html',
    styleUrls: ['./single-date-range-simple.component.scss'],
})
export class SingleDateRangeSimpleComponent implements OnInit
{
    @Input() defaultToFiscalYear = false;
    @Input() filterOnChange = false;
    @Input() doMatSelect = false;

    @Output() filterReady: EventEmitter<SingleDateRangeFilter> = new EventEmitter<SingleDateRangeFilter>();
    @Output() filterResults: EventEmitter<SingleDateRangeFilter> = new EventEmitter<SingleDateRangeFilter>();

    filters: SingleDateRangeFilter;
    isAdmin = false;
    isReady = false;
    range = new UntypedFormControl();
    ranges = [
        'This Month',
        'Last Month',
        'This Fiscal Year',
        'Last Fiscal Year',
        'This Year',
        'Last Year',
    ];
    selectedRange = '';

    private fiscalStartMonth: number;

    constructor(
            private _filterService: FilteringService,
            private _organizationService: OrganizationService,
    ) {
    }

    ngOnInit() {
        this.filters = {
            startDate: moment().startOf('year'),
            endDate: moment().endOf('year'),
        };

        this.selectedRange = 'This Fiscal Year';
        if (!this.doMatSelect) {
            this.range.setValue(this.selectedRange);
        }

        this._organizationService
                .getOrganizationById(null, ['profile'])
                .pipe(untilDestroyed(this))
                .subscribe((org: Organization) => {
                    this.fiscalStartMonth = org.profile.fiscalPeriodStart;
                    if (this.defaultToFiscalYear) {
                        this._filterService.setThisFiscalYearDatePicker(
                                this.filters,
                                this.fiscalStartMonth,
                        );
                    }
                    this.getFilters();
                    this.filterReady.emit(this.filters);
                });
    }

    selectionChanged() {
        if (this.filterOnChange) {
            this.getReport();
        }
    }

    getFilters() {
        const newRange = this.doMatSelect ? this.selectedRange : this.range.value;
        switch (newRange) {
            case 'This Month': {
                this._filterService.setThisMonthDatePicker(this.filters);
                break;
            }
            case 'Last Month': {
                this._filterService.setLastMonthDatePicker(this.filters);
                break;
            }
            case 'This Fiscal Year': {
                this._filterService.setThisFiscalYearDatePicker(this.filters, this.fiscalStartMonth);
                break;
            }
            case 'Last Fiscal Year': {
                this._filterService.setLastFiscalYearDatePicker(this.filters, this.fiscalStartMonth);
                break;
            }
            case 'This Year': {
                this._filterService.setThisCalendarYearDatePicker(this.filters);
                break;
            }
            case 'Last Year': {
                this._filterService.setLastCalendarYearDatePicker(this.filters);
                break;
            }
        }
    }

    getReport() {
        this.getFilters();
        this.filterResults.emit(this.filters);
    }
}
